<script>
	import Button from '../Button/Button.svelte';
	import Icon from '../Icon/Icon.svelte';
	import UserAvatar from '../UserAvatar/UserAvatar.svelte';
	import { clickOutside } from '@resider/utils';

	export let isMenuVisible = false;
	export let userName = '';
	export let userPicture = '';

	function handleClickMenuItem() {
		isMenuVisible = false;
	}

	function toggleMenu() {
		isMenuVisible = !isMenuVisible;
	}

	function hideMenu() {
		isMenuVisible = false;
	}
</script>

<div class="desktop-navigation" use:clickOutside={hideMenu}>
	<button class="toggle" on:click={toggleMenu}>
		<Icon name="menu" />

		<UserAvatar {userPicture} {userName} />
	</button>

	{#if isMenuVisible}
		<nav>
			<menu>
				<slot name="menu" {Button} {handleClickMenuItem} />
			</menu>
			<div class="languages">
				<slot name="languages" {Button} {handleClickMenuItem} />
			</div>
		</nav>
	{/if}
</div>

<style>.desktop-navigation{position:relative;float:right}.desktop-navigation :global(.icon){--size:1.5rem}.toggle{--avatar-size:2rem;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:hsla(var(--hsl-white));border:1px hsla(var(--hsl-gray-light)) solid;border-radius:2rem;cursor:pointer;display:flex;gap:.5rem;padding:.375rem .375rem .375rem .625rem}.toggle :global(.icon){--size:1.25rem}menu,nav{display:grid}nav{grid-gap:1.5rem;gap:1.5rem;background:hsla(var(--hsl-white));border:1px hsla(var(--hsl-gray-light)) solid;border-radius:1.25rem;box-shadow:var(--shadow-sm);padding:1rem;position:absolute;right:0;top:calc(100% + .375rem);width:17rem}menu{grid-gap:1rem;gap:1rem;list-style:none}menu :global(.auth-ctas){display:grid;grid-gap:.75rem;gap:.75rem}menu :global(li){display:contents}menu :global(li .button){justify-content:flex-start;border-radius:3rem;padding:0}menu :global(li .button):where(:hover,.tertiary){--icon-wrapper-background:transparent}.languages{display:grid;grid-gap:1rem;gap:1rem;grid-template-columns:1fr 1fr}</style>
